// export const DOMAIN = 'junengcloud.com'
// export const seatType = 1 //  1 汇电环境 2 粤电环境 3 演示环境
export const {DOMAIN, NODE_ENV, logo, mainTitle, subTitle, webBackground, isShowParticles, supportPic, logoutUrl} = process.env
export const remoteEnv = ['development', 'release', 'hyy', 'yihai', 'zhenjiang']
export const ROOT_APP_ID = 1 // 汇电平台ID
export const COMP_APP_ID = 2 // 公司管理中心ID
export const NORMAL_APP_ID = 3 // 应用管理中心ID
export const ADMIN_USER_ID = 1 // 公司管理员ID
export const WXid = 'wx_reg'
export const WXappid = 'ww2a38a1520030b335'
export const WXagentid = '1000002'
export const WXredirectUri = '/'

export const fliterAppList = function (path) { // 汇电公司管理员和公司应用管理 员 新增编辑管理员 应用选择的控制
  let fliterAppIds = []
  let defaultCheck = []
  if (path === '/adminuser') {
    fliterAppIds = [ROOT_APP_ID]
    defaultCheck = [COMP_APP_ID, NORMAL_APP_ID]
  } else if (path === '/appuser') {
    fliterAppIds = [ROOT_APP_ID, COMP_APP_ID] // 过滤显示
    defaultCheck = [NORMAL_APP_ID] // 默认选择
  }
  return {fliterAppIds, defaultCheck}
}
export const insertSystemAppid = function (arr) {
  arr.splice(0, 0, ROOT_APP_ID, COMP_APP_ID, NORMAL_APP_ID)
  return arr
}
export const generateAppId = function (path) { // 汇电公司管理员和公司应用管理员 页面时候获取 新增编辑 列表需要的 APPID
  return path === '/adminuser' ? COMP_APP_ID : path === '/appuser' ? NORMAL_APP_ID : ''
}



// WEBPACK FOOTER //
// ./src/config/index.js